"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authSagas = void 0;

var _auth = require("./auth"); // Export action watchers


var authSagas = {
  watchAuthenticate: _auth.watchAuthenticate,
  watchFetchMe: _auth.watchFetchMe,
  watchFetchOauthProviders: _auth.watchFetchOauthProviders,
  watchTestOauthEnabled: _auth.watchTestOauthEnabled,
  watchInvalidateToken: _auth.watchInvalidateToken,
  watchNewToken: _auth.watchNewToken,
  watchUsernameLogin: _auth.watchUsernameLogin,
  watchNerscLogin: _auth.watchNerscLogin,
  watchLoadTokenFromApiKey: _auth.watchLoadTokenFromApiKey
};
exports.authSagas = authSagas;